import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTinderComponent } from './simple-icons-tinder.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTinderComponent ],
    exports:      [ SimpleIconsTinderComponent ],
    bootstrap:    []
})
export class SimpleIconsTinderModule {}
